var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template"},[_c('div',{staticClass:"raw",domProps:{"innerHTML":_vm._s(_vm.rawHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }